export const SET_INITIAL_DASHBOARD = "dashboard/SET_INITIAL_DASHBOARD";
export const RESET_STATUS = "dashboard/RESET_STATUS";
export const SET_PROJECT_TYPE_OPTION = "dashboard/SET_PROJECT_TYPE_OPTION";
export const SET_DATA = "dashboard/SET_DATA";
export const SET_CLAIMS_RECEIVED_TYPE_OPTION =
  "dashboard/SET_CLAIMS_RECEIVED_TYPE_OPTION";
export const SET_GROUP_TABLE = "dashboard/SET_GROUP_TABLE";
export const SET_AGG_TABLE_EXPAND_KEY = "dashboard/SET_AGG_TABLE_EXPAND_KEY";
